module.exports = __webpack_public_path__ + "static/media/authority.cfd83de7.svg";